import { domScheduler } from "@studiometa/js-toolkit/utils";
import { fallbackStore as store } from "../utils/storage/index.js";
const themes = /* @__PURE__ */ new Set(["dark", "light"]);
const defaultTheme = "light";
const themeCallbacks = [];
function getTheme() {
  return store.get("theme") || defaultTheme;
}
function themeIsDark() {
  return getTheme() === "dark";
}
function themeIsLight() {
  return getTheme() === "light";
}
function themeUpdateDOM(value = getTheme()) {
  domScheduler.write(() => {
    document.documentElement.classList.toggle("dark", value === "dark");
  });
}
function setTheme(value = getTheme()) {
  if (!themes.has(value)) {
    console.warn(`The "${value}" theme is not valid.`);
    value = defaultTheme;
  }
  store.set("theme", value);
  themeUpdateDOM(value);
  themeCallbacks.forEach((callback) => callback(value));
}
function watchTheme(callback) {
  const index = themeCallbacks.length;
  themeCallbacks.push(callback);
  return () => {
    themeCallbacks.splice(index, 1);
  };
}
export {
  getTheme,
  setTheme,
  themeIsDark,
  themeIsLight,
  themeUpdateDOM,
  watchTheme
};
//# sourceMappingURL=theme.js.map
